import noop from 'utils/noop';

export const recordError = noop;
export const sendUnsentReports = noop;
export const setUserId = noop;
export const setAttribute = noop;
export const log = noop;
export const getCrashlytics = noop;

const crashlytics = () => {
  return {
    recordError: noop,
    sendUnsentReports: noop,
    setUserId: noop,
    setAttribute: noop,
    log: noop,
    crash: noop,
  };
};

export default crashlytics;
